module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2e0c4790f8f9cf28e3c346b9cef0fcb6.svg";